import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "../gameData";
import FontKeys from "../FontKeys";

export default class Popup extends Phaser.GameObjects.Container
{
    constructor(scene, type)
    {
        super(scene);
        scene.add.existing(this);

        this.type = type;
		
        this.createItem();
    }

	createItem() {
        this.btnCont = this.scene.add.container();

        this.bgShade = ABCyaPhaser.Graphics.addRect(this.scene.mid.x, this.scene.mid.y, this.scene.mid.x*2, this.scene.mid.y*2, "0x000000", this).setAlpha(0);

        let txt;
        if(this.type == "intro"){
            const fixedString = ABCyaPhaser.Localization.instance.getLocalizedString('instruct').replace(/ /g, "    ");
            this.popupTxt = ABCyaPhaser.Text.addText(0, this.scene.mid.y/2, 40, "0xFFFFFF", gameData.GAME_FONTS[0], fixedString, this).setWordWrapWidth(500);

            this.okBtn = ABCyaPhaser.Buttons.addSimpleButton(this.scene.mid.x, this.scene.mid.y + this.scene.mid.y/2, "play_button", null, ()=>{
                this.okBtn.setEnabled(false);
                this.clickHandler(this.okBtn);
            }, this).setEnabled(false).setAlpha(0);

            this.scene.time.delayedCall(500, ()=>{this.playIntroSound();});
        }

        if(this.type == "paused"){
            this.popupTxt = ABCyaPhaser.Text.addText(0, 0, 65, "0xFFD493", gameData.GAME_FONTS[1], ABCyaPhaser.Localization.instance.getLocalizedString('pause_screen.paused'), this);

            this.resumeBtn = ABCyaPhaser.Buttons.addSimpleButton(0, 0, "resume_button", null, ()=>{
                this.resumeBtn.setEnabled(false);
                this.replayBtn.setEnabled(false);
                this.clickHandler(this.resumeBtn);
            }, this.btnCont, {disabledTint: 0xffffff}).setEnabled(false);
            const resumeText = ABCyaPhaser.Text.addText(-this.scene.mid.x/2, 0, 56, 0xffad08, FontKeys._pt_sansregular, ABCyaPhaser.Localization.instance.getLocalizedString('pause_screen.resume'), this.btnCont);
            ABCyaPhaser.Text.resizeFontToFitWidth(resumeText, 240);

            this.replayBtn = ABCyaPhaser.Buttons.addSimpleButton(0, 0, "new_game_button", null, ()=>{
                this.resumeBtn.setEnabled(false);
                this.replayBtn.setEnabled(false);
                this.clickHandler(this.replayBtn);
            }, this.btnCont, {disabledTint: 0xffffff}).setEnabled(false);
            const replayText = ABCyaPhaser.Text.addText(-this.scene.mid.x/2, 0, 56, 0xffad08, FontKeys._pt_sansregular, ABCyaPhaser.Localization.instance.getLocalizedString('pause_screen.new_game'),this.btnCont);
            ABCyaPhaser.Text.resizeFontToFitWidth(replayText, 280);

            if(!gameData.DESKTOP){
                this.popupTxt.y = 250;
                this.btnCont.x = this.scene.mid.x;
                this.btnCont.y = this.scene.mid.y/2 + 300;
                this.resumeBtn.y = -this.scene.mid.y/3.5;
                this.replayBtn.x = 25;
                resumeText.x = this.resumeBtn.x + 50;
                replayText.x = this.replayBtn.x + 50;
                resumeText.y = this.resumeBtn.y;
            } else {
                this.popupTxt.y = 250;
                this.btnCont.x = this.scene.mid.x;
                this.btnCont.y = this.scene.mid.y/2 + 300;
                this.resumeBtn.x = -this.scene.mid.x/2;
                this.replayBtn.x = this.scene.mid.x/2;
                resumeText.x = this.resumeBtn.x + 50;
                replayText.x = this.replayBtn.x + 50;
            }
        }

        if(this.type == "end") {
            ABCyaPhaser.Audio.playOneShot("Times_Up", this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

            this.popupTxtBg = ABCyaPhaser.Images.addImage(0, 0, "text_display", this);
            this.popupTxtBg2 = ABCyaPhaser.Images.addImage(0, 0, "text_display", this);

            this.popupTxt = ABCyaPhaser.Text.addText(this.scene.mid.x, this.scene.mid.y/2 + 36, 65, "0xFFD493", gameData.GAME_FONTS[1], ABCyaPhaser.Localization.instance.getLocalizedString('end_screen.time_up'), this).setWordWrapWidth(this.scene.scale.width-100).setOrigin(0.5, 1);

            this.replayBtn = ABCyaPhaser.Buttons.addSimpleButton(this.scene.mid.x, this.scene.mid.y*2 - this.scene.mid.y/2, "new_game_button", null, ()=>{
                this.replayBtn.setEnabled(false);
                this.clickHandler(this.replayBtn);
            }, this.btnCont, {disabledTint: 0xffffff}).setEnabled(false);
            this.replayBtnText = ABCyaPhaser.Text.addText(this.replayBtn.x + 50, this.replayBtn.y, 56, 0xffad08, FontKeys._pt_sansregular, ABCyaPhaser.Localization.instance.getLocalizedString('pause_screen.new_game'),this.btnCont);
            ABCyaPhaser.Text.resizeFontToFitWidth(this.replayBtnText, 280);

            const correctText = (ABCyaPhaser.Localization.instance.getLocalizedString('end_screen.correct') + " " + gameData.WORDS_MADE).replace(/ /g, "    ");
            const incorrectText = (ABCyaPhaser.Localization.instance.getLocalizedString('end_screen.misses') + " " + gameData.WORDS_MISSED).replace(/ /g, "    ");
            this.popupTxt2 = ABCyaPhaser.Text.addText(0, -1, 30, "0xFFFFFF", gameData.GAME_FONTS[0], correctText, this);
            this.popupTxt3 = ABCyaPhaser.Text.addText(0, 0, 30, "0xFFFFFF", gameData.GAME_FONTS[0], incorrectText, this);

            this.popupTxt2.x = this.popupTxtBg.x = this.popupTxt3.x = this.popupTxtBg2.x = this.popupTxt.x;
            this.popupTxt2.y = this.popupTxtBg.y = this.popupTxt.y + this.popupTxt.height + 40;
            this.popupTxt3.y = this.popupTxtBg2.y = this.popupTxtBg.y + this.popupTxtBg.height*1.5;
        }

        this.add(this.btnCont);

        this.popupTxt.x = this.scene.mid.x;

        this.showPopup();
	};

    playIntroSound(){
        ABCyaPhaser.Audio.playOneShot("Type_on_Rockets", this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

        ABCyaPhaser.Tweens.addTween(this.okBtn, 1000, {alpha:1, delay:2000}, Phaser.Math.Easing.Linear, ()=>{
            this.popupReady();
        });
    };

    countdown(){
        ABCyaPhaser.Audio.playOneShot(gameData.INTRO_SOUNDS[0], this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

        this.popupTxt.destroy();
        this.okBtn.destroy();

        this.start = ABCyaPhaser.Text.addText(this.scene.mid.x, this.scene.mid.y, 180, 0x17a163, FontKeys._neuropolregular, ABCyaPhaser.Localization.instance.getLocalizedString('blast_off'), this);
        ABCyaPhaser.Text.resizeFontToFitWidth(this.start, this.scene.scale.width-100);
        this.start.setAlpha(0).setScale(0).setStroke('#dbe47f', 8);

        this.three = ABCyaPhaser.Images.addImage(this.scene.mid.x, this.scene.mid.y, "three", this).setAlpha(0).setScale(0);
        this.two = ABCyaPhaser.Images.addImage(this.scene.mid.x, this.scene.mid.y, "two", this).setAlpha(0).setScale(0);
        this.one = ABCyaPhaser.Images.addImage(this.scene.mid.x, this.scene.mid.y, "one", this).setAlpha(0).setScale(0);

        ABCyaPhaser.Tweens.addTween(this.three, 1000, {alpha:1, scale:1}, Phaser.Math.Easing.Elastic.Out, ()=>{
            this.destroyNumber(this.three);
        });
        ABCyaPhaser.Tweens.addTween(this.two, 1000, {alpha:1, scale:1, delay:1000}, Phaser.Math.Easing.Elastic.Out, ()=>{
            this.destroyNumber(this.two);
        });
        ABCyaPhaser.Tweens.addTween(this.one, 1000, {alpha:1, scale:1, delay:2000}, Phaser.Math.Easing.Elastic.Out, ()=>{
            this.destroyNumber(this.one);
        });
        ABCyaPhaser.Tweens.addTween(this.start, 3000, {alpha:1, scale:.8, delay:3000}, Phaser.Math.Easing.Back.Out, ()=>{
            this.destroyNumber(this.start);
        });
    };

    destroyNumber(obj){
        if(obj == this.one) ABCyaPhaser.Audio.playOneShot(gameData.INTRO_SOUNDS[3], this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE); 
        if(obj == this.two) ABCyaPhaser.Audio.playOneShot(gameData.INTRO_SOUNDS[2], this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
        if(obj == this.three) ABCyaPhaser.Audio.playOneShot(gameData.INTRO_SOUNDS[1], this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

        //animate in all the pieces
        if(obj != this.start){
            obj.destroy();
        } else {
            this.scene.time.delayedCall(500, ()=>{this.scene.destroyIntro();});
        }
    };

    showPopup(){
        //animate in all the pieces
        this.alpha = 0;

        ABCyaPhaser.Tweens.addTween(this.bgShade, 750, {alpha:.75}, Phaser.Math.Easing.Linear);

        if(this.type != "intro") {
            ABCyaPhaser.Tweens.addTween(this, 750, {alpha:1}, Phaser.Math.Easing.Linear, ()=>{
                this.popupReady();
            });
        } else {
            ABCyaPhaser.Tweens.addTween(this, 750, {alpha:1}, Phaser.Math.Easing.Linear);
        }
    };

    popupReady(){
        //add listeners and whatnot
        this.okBtn?.setEnabled(true);
        this.resumeBtn?.setEnabled(true);
        this.replayBtn?.setEnabled(true);
    };

    clickHandler(btn){
        ABCyaPhaser.Audio.playOneShot("Click", this.scene);

        //Resume the game. Turn back on all listeners
        if(btn == this.resumeBtn){
            this.scene.destroyPopup("resume");
        }
        if(btn == this.replayBtn){
            this.scene.cleanUp();
        }

        //Reset the game from the very beginning
        if(btn == this.okBtn){
            this.countdown();
        }
    };
}